import React, { Component } from "react";
import "./DashboardCEO.css";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Switch } from "react-router";
import { Redirect } from "react-router-dom";
import NavBar from "../../PreComps/Includes/NavBar.jsx";
import PersonalInfo from "../PersonalInfo/PersonalInfo.jsx";
import Education from "../Education/Education";
import MonthlyReports from "../MonthlyReport/MonthlyReports";
import FamilyInfo from "../FamilyInfo/FamilyInfo.jsx";
import WorkExperience from "../WorkExperience/WorkExperience.jsx";
import LeaveApplicationEmp from "../LeaveApplication/LeaveApplicationEmp.jsx";
import NotFound404 from "../../PreComps/Includes/NotFound404";
import LeaveManage from "../LeaveApplicationCEOManage/LeaveApplicationCEO";
import ViewReports from "../ViewReports/ViewReportsCEO";
import PerfEvalCEO from "../PerfEval/PerfEvalCEO";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faUser,
  faFileAlt,
  faUniversity,
  faBriefcase,
  faMale,
} from "@fortawesome/free-solid-svg-icons";

class DashboardCEO extends Component {
  state = {
    redirect: true,
    checked: true,
  };
  handleChange = (checked) => {
    console.log("switch");
    // var sidebarV = this.refs.sidebar;
    // var sidebarV = React.findDOMNode( this.refs.sidebar);
    // sidebarV.style.disply="none";

    if (this.state.checked === true) {
      // document.getElementById("sidebar").setAttribute("style", "display:none")
      document.getElementById("sidebar").setAttribute("class", "display-none");
    }
    // document.getElementById("sidebar").setAttribute("style", "display:block");
    else {
      document.getElementById("sidebar").setAttribute("class", "display-block");
    }
    this.setState({ checked });
  };

  render() {
    return (
      <Router>
        {/* <Redirect to='/login'  /> */}

        <div id="outer-main-div">
          <div id="outer-nav">
            {/* <NavBar loginInfo={this.props.data} /> */}
            <NavBar
              loginInfo={this.props.data}
              checked={this.state.checked}
              handleChange={this.handleChange}
              onLogout={this.props.onLogout}
            />
          </div>

          <div id="main-non-nav">
            <div id="sidebar">
              <div id="sidebar-top-content" />
              <div id="main-title" className="main-title-employee">
                <FontAwesomeIcon icon={faUsers} className="sidebar-icon" />
                Dashboard
              </div>
              <ul className="navbar-ul">
                <li
                  style={{
                    color: "white",
                    borderBottom: "1px solid white",
                    borderTop: "1px solid white",
                  }}
                >
                  Manage
                </li>
                <li>
                  <Link to={"/ceo/" + this.props.data["_id"] + "/leave-manage"}>
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      className="sidebar-icon"
                    />
                    Manage Leave Application
                  </Link>
                </li>

                <li>
                  <Link to={"/ceo/" + this.props.data["_id"] + "/view-reports"}>
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      className="sidebar-icon"
                    />
                    View Monthly Reports
                  </Link>
                </li>

                <li>
                  <Link
                    to={
                      "/ceo/" +
                      this.props.data["_id"] +
                      "/performance-evaluation"
                    }
                  >
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      className="sidebar-icon"
                    />
                    Performance Evaluation
                  </Link>
                </li>
                <li
                  style={{
                    color: "white",
                    borderBottom: "1px solid white",
                    borderTop: "1px solid white",
                  }}
                >
                  Personal
                </li>

                <li>
                  <Link
                    to={"/ceo/" + this.props.data["_id"] + "/personal-info"}
                  >
                    <FontAwesomeIcon icon={faUser} className="sidebar-icon" />
                    Personal Information
                  </Link>
                </li>
                <li>
                  <Link to={"/ceo/" + this.props.data["_id"] + "/education"}>
                    <FontAwesomeIcon
                      icon={faUniversity}
                      className="sidebar-icon"
                    />
                    Education
                  </Link>
                </li>
                <li>
                  <Link to={"/ceo/" + this.props.data["_id"] + "/family-info"}>
                    <FontAwesomeIcon icon={faMale} className="sidebar-icon" />
                    Dependents
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/ceo/" + this.props.data["_id"] + "/work-experience"}
                  >
                    <FontAwesomeIcon
                      icon={faBriefcase}
                      className="sidebar-icon"
                    />
                    WorkExp
                  </Link>
                </li>
                <li>
                  <Link
                    to={
                      "/ceo/" +
                      this.props.data["_id"] +
                      "/leave-application-emp"
                    }
                  >
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      className="sidebar-icon"
                    />
                    Leave Application
                  </Link>
                </li>
                <li>
                  <Link
                    to={"/ceo/" + this.props.data["_id"] + "/monthly-reports"}
                  >
                    <FontAwesomeIcon
                      icon={faFileAlt}
                      className="sidebar-icon"
                    />
                    Monthly Reports
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div id="sidebar-top-content" /> */}
            <div id="main-area">
              <div id="sidebar-top-content" />
              {/* //table */}
              {/* <RoleHR/> */}
              <Switch>
                {/* <Route
                  path="/ceo/:id/personal-info"
                  exact
                  component={PersonalInfoF}
                /> */}
                <Route
                  exact
                  path="/ceo/:id/personal-info"
                  render={(props) => (
                    <PersonalInfo data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/education"
                  render={(props) => (
                    <Education data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/monthly-reports"
                  render={(props) => (
                    <MonthlyReports data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/family-info"
                  render={(props) => (
                    <FamilyInfo data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/work-experience"
                  render={(props) => (
                    <WorkExperience data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/leave-application-emp"
                  render={(props) => (
                    <LeaveApplicationEmp data={this.props.data} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/manage-leave-application"
                  render={(props) => (
                    <LeaveApplicationEmp data={this.props.data} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/leave-manage"
                  render={(props) => (
                    <LeaveManage data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/view-reports"
                  render={(props) => (
                    <ViewReports data={this.props.data} back={false} />
                  )}
                />
                <Route
                  exact
                  path="/ceo/:id/performance-evaluation"
                  render={(props) => (
                    <PerfEvalCEO data={this.props.data} back={false} />
                  )}
                />
                <Route render={() => <NotFound404 />} />
              </Switch>
            </div>
          </div>
        </div>
      </Router>
    );
  }
}

export default DashboardCEO;
